export default __webpack_public_path__ + "static/5-625e2d54553935ec0f844e6f0b7bdf74.png";